import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import EmptyDocumentsStateSvg from '@web/assets/svg/Misc/empty-documents-state.svg';
import EmptyDocumentsSearchSvg from '@web/assets/svg/Misc/empty-documents-search.svg';

const SVG_DISPLACEMENT = 50;

type Props = {
  isSearch: boolean;
};

const EmptyDocumentsState = ({ isSearch }: Props) => (
  <Column mTop={60} alignItems="center">
    {isSearch ? (
      <Column mTop={20} mBottom={20}>
        <EmptyDocumentsSearchSvg />
      </Column>
    ) : (
      <Column mTop={20} mLeft={SVG_DISPLACEMENT} mBottom={20}>
        <EmptyDocumentsStateSvg />
      </Column>
    )}
    {isSearch ? (
      <Column>
        <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
          {gettext('No results!')}
        </Text14>
        <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
          {gettext('Try modifying your search or checking for typos.')}
        </Text14>
      </Column>
    ) : (
      <Text14 textAlign="center" themeColor={ThemeColorType.gray} semiBold>
        {gettext('No documents added yet')}
      </Text14>
    )}
  </Column>
);

export default EmptyDocumentsState;
